/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */
import { api } from 'utils/index';

export const query = (params) => api.get('menus', { params });

const defaultState = {
    items: [],
    item: {},
    options: [],
    meta: {
        total: 0,
        per_page: 0,
        current_page: 0,
    },
    statistic: {
        total: 0,
        meta: {},
    },
    errors: null,
    duplicated: false,
};

export default {
    name: 'menu',
    state: defaultState,
    reducers: {
        reset: (state) => ({
            ...state,
            item: {},
            saved: false,
            errors: null,
            duplicated: false,
        }),
        fetchResponse: (state, payload) => ({
            ...state,
            items: payload.data,
            meta: payload.meta,
        }),
        findResponse: (state, payload) => ({
            ...state,
            item: payload,
        }),
        fetchOptionResponse: (state, payload) => ({
            ...state,
            options: payload,
        }),
        saveLoading: (state) => ({
            ...state,
            errors: null,
        }),
        saveResponse: (state, payload) => {
            if (payload.errors) {
                return {
                    ...state,
                    errors: payload.errors,
                    saved: false,
                };
            }

            return {
                ...state,
                saved: true,
                errors: null,
            };
        },
        duplicateResponse: (state, payload) => {
            if (payload.errors) {
                return {
                    ...state,
                    errors: payload.errors,
                    duplicated: false,
                };
            }

            return {
                ...state,
                duplicated: true,
                errors: null,
            };
        },
    },
    effects: {
        async fetch(params) {
            await query(params)
                .then((response) => this.fetchResponse(response));
        },

        async fetchOptions() {
            await api.get('menus/options')
                .then((response) => this.fetchOptionResponse(response));
        },

        async find(id) {
            await api.get(`menus/${id}`)
                .then((response) => this.findResponse(response));
        },

        async duplicate(id) {
            await api.post(`menus/${id}/duplicate`)
                .then((response) => this.duplicateResponse(response));
        },

        async save(formData) {
            this.saveLoading();
            const getId = formData.get('id');
            const url = getId ? `menus/${getId}` : 'menus';

            await api.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((response) => this.saveResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, (state) => state.menu, (menu) => menu.items);
        },
        find() {
            return createSelector(
                this.all,
                (state, selectedId) => selectedId,
                (menus, selectedId) => menus.find((menu) => menu.id === selectedId),
            );
        },
    }),
};
